module.exports = __webpack_public_path__ + "img/2x.45dfd6a.jpg";